import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Container, Breadcrumb } from "react-bootstrap";
import { getTermsNconditions } from "../services/services";

const TermsConditions = () => {

    const [TNC, setTNC] = useState({ title: "", content: "" })

    const getTermsnCon = async () => {
        await getTermsNconditions().then((resp) => {
            setTNC({ ...TNC, title: resp.data.title, content: resp.data.content })
        })
    }

    useEffect(() => {
        getTermsnCon()
    }, [])

    return (
        <div>
            <Header />
            <section className="bnner_imgswork py-5">
                <div className="cntctbnnr_img text-center">
                    <h1>{TNC.title}</h1>
                    <div className="innner_hmm text-center">
                        <Breadcrumb>
                            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                            <Breadcrumb.Item active>
                                Terms & Conditions
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </section>
            <div className="prvcy_policy">
                <Container>
                    {/* <div className="pg_hdng text-center">
                <h1>Privacy Policy</h1>
            </div> */}
                    <div className="prvcy_cntnt">
                        <p dangerouslySetInnerHTML={{__html: TNC.content}}>
                            {/* {TNC.content} */}
                        </p>
                        {/* <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Cupiditate officiis quae debitis perferendis
                            voluptates, optio aut suscipit expedita quod et
                            exercitationem! Dolor, quos voluptatem! Molestiae
                            consequatur ex provident eius possimus? Lorem ipsum
                            dolor sit amet consectetur adipisicing elit.
                        </p>
                        <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Cupiditate officiis quae debitis perferendis
                            voluptates, optio aut suscipit expedita quod et
                            exercitationem! Dolor, quos voluptatem! Molestiae
                            consequatur ex provident eius possimus? Lorem ipsum
                            dolor sit amet consectetur adipisicing elit.
                            Cupiditate officiis quae debitis perferendis
                            voluptates, optio aut suscipit expedita quod et
                            exercitationem! Dolor, quos voluptatem! Molestiae
                            consequatur ex provident eius possimus?Lorem ipsum
                            dolor sit amet consectetur adipisicing elit.
                            Cupiditate officiis quae debitis perferendis
                            voluptates, optio aut suscipit expedita quod et
                            exercitationem! Dolor, quos voluptatem! Molestiae
                            consequatur ex provident eius possimus?Lorem ipsum
                            dolor sit amet consectetur adipisicing elit.
                            Cupiditate officiis quae debitis perferendis
                            voluptates, optio aut suscipit expedita quod et
                            exercitationem! Dolor, quos voluptatem! Molestiae
                            consequatur ex provident eius possimus?
                        </p>
                        <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Cupiditate officiis quae debitis perferendis
                            voluptates, optio aut suscipit expedita quod et
                            exercitationem! Dolor, quos voluptatem! Molestiae
                            consequatur ex provident eius possimus? Lorem ipsum
                            dolor sit amet consectetur adipisicing elit.
                            Cupiditate officiis quae debitis perferendis
                            voluptates, optio aut suscipit expedita quod et
                            exercitationem! Dolor, quos voluptatem! Molestiae
                            consequatur ex provident eius possimus?Lorem ipsum
                            dolor sit amet consectetur adipisicing elit.
                            Cupiditate officiis quae debitis perferendis
                            voluptates, optio aut suscipit expedita quod et
                            exercitationem! Dolor, quos voluptatem! Molestiae
                            consequatur ex provident eius possimus?Lorem ipsum
                            dolor sit amet consectetur adipisicing elit.
                            Cupiditate officiis quae debitis perferendis
                            voluptates, optio aut suscipit expedita quod et
                            exercitationem! Dolor, quos voluptatem! Molestiae
                            consequatur ex provident eius possimus?
                        </p> */}
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default TermsConditions;
